var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3636 3V4.63636H5.8125L15.8608 14.6847L14.6847 15.8608L4.63636 5.8125V10.3636H3V3H10.3636ZM21 6.27273V21H6.27273V10.3636L7.90909 12V19.3636H19.3636V7.90909H12L10.3636 6.27273H21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuExpand);
export default __webpack_public_path__ + "static/media/ic-menu-expand.b8537e40924d15ea209164e5ce5120ad.svg";
export { ForwardRef as ReactComponent };